/**
 * Success Modal Component
 */

import { SuccessIcon } from "@/assets/svg";
import { Modal } from "../modal";

export interface SuccessModalProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly title?: string;
  readonly message?: string;
}

export const SuccessModal = ({
  isOpen,
  onClose,
  title = "Success",
  message = "New reward has been added.",
}: SuccessModalProps): React.JSX.Element => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="rounded-2xl w-[400px] max-w-[90vw] relative">
        {/* Success Icon */}
        <div className="flex justify-center mb-6">
          <SuccessIcon />
        </div>

        {/* Title */}
        <h2 className="text-2xl font-bold text-center text-gray-900 mb-3">
          {title}
        </h2>

        {/* Message */}
        <p className="text-center text-gray-600 mb-8">
          {message}
        </p>

        {/* OK Button */}
        <button
          onClick={onClose}
          className="w-full py-3 px-6 bg-[#001a41] text-white font-semibold rounded-lg hover:bg-[#002a5a] transition-colors focus:outline-none focus:ring-2 focus:ring-[#001a41] focus:ring-offset-2"
        >
          OK
        </button>
      </div>
    </Modal>
  );
};
